module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa",
    class: {
      'fa-check': _vm.ok
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c753bc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/YesNo.vue
// module id = 629
// module chunks = 0